/* eslint-disable import/prefer-default-export */
export const setDefaultFallback = products =>
  products.map(product => {
    const hasDefaultComposition = product.compositions.some(composition => composition.default);
    if (hasDefaultComposition) return product;

    return {
      ...product,
      compositions: product.compositions.map((composition, index) => ({
        ...composition,
        default: index === 0
      }))
    };
  });
